
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/validate/resetpassword/[info]",
      function () {
        return require("private-next-pages/validate/resetpassword/[info].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/validate/resetpassword/[info]"])
      });
    }
  